export const privacyScannerTour = {
    module: 'privacy_scanner',
    title: 'Privacy Scanner Tour',
    title_vi: 'Tour Quét riêng tư',
    description: 'As the Privacy Analyst (P-VN-06), run continuous monitoring scans to detect cookie consent violations, unauthorized trackers, and policy gaps -- generating evidence for ePrivacy and GDPR compliance.',
    description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: As the Privacy Analyst (P-VN-06), run continuous monitoring scans to detect cookie consent violations, unauthorized trackers, and policy gaps -- generating evidence for ePrivacy and GDPR compliance.',
    estimated_duration_seconds: 44,
    steps: [
        {
            step_id: 'ps_monitoring',
            navigate_to: '/admin/privacy-scanner/monitoring',
            target: '.dm-page',
            title: 'Privacy Monitoring Dashboard',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Privacy Monitoring Dashboard',
            description: 'As the Privacy Analyst, you will monitor all web properties here. Compliance scores, active issues, and scan schedules give you continuous visibility into cookie and tracker compliance.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: As the Privacy Analyst, you will monitor all web properties here. Compliance scores, active issues, and scan schedules give you continuous visibility into cookie and tracker compliance.',
            position: 'bottom',
        },
        {
            step_id: 'ps_scan_results',
            target: '.dm-table',
            title: 'Recent Scan Results',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Recent Scan Results',
            description: 'Browse completed scan results. Each entry shows the property, compliance score, and issue count -- prioritize low-scoring properties for immediate remediation.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Browse completed scan results. Each entry shows the property, compliance score, and issue count -- prioritize low-scoring properties for immediate remediation.',
            position: 'bottom',
        },
        {
            step_id: 'ps_click_result',
            target: '.dm-table tbody tr:first-child',
            title: 'View Scan Detail',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: View Scan Detail',
            description: 'Click any scan result to see individual findings with severity levels and remediation guidance. Each finding maps to a specific ePrivacy or GDPR requirement.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Click any scan result to see individual findings with severity levels and remediation guidance. Each finding maps to a specific ePrivacy or GDPR requirement.',
            position: 'bottom',
            action: { type: 'click', target: '.dm-table tbody tr:first-child' },
            duration_ms: 100,
        },
        {
            step_id: 'ps_settings',
            navigate_to: '/admin/privacy-scanner/monitoring/settings',
            target: '.dm-page',
            title: 'Scanner Settings',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Scanner Settings',
            description: 'Configure scan frequency, target URLs, cookie categories, and the compliance rules to check against. Settings here define your continuous monitoring baseline.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Configure scan frequency, target URLs, cookie categories, and the compliance rules to check against. Settings here define your continuous monitoring baseline.',
            position: 'bottom',
        },
        {
            step_id: 'ps_add_url',
            target: '[data-testid="target-url"]',
            title: 'Add a Target URL',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Add a Target URL',
            description: 'Enter the URL of a website or application to scan. Include all customer-facing properties to ensure full coverage of your consent implementation.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Enter the URL of a website or application to scan. Include all customer-facing properties to ensure full coverage of your consent implementation.',
            position: 'bottom',
            action: {
                type: 'fill',
                target: '[data-testid="target-url"]',
                value: '[TOUR] https://example.com',
            },
        },
        {
            step_id: 'ps_select_frequency',
            target: '[data-testid="scan-frequency"]',
            title: 'Set Scan Frequency',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Set Scan Frequency',
            description: 'Choose the scan cadence: daily, weekly, or on demand. High-traffic customer-facing sites should be scanned daily to catch consent violations before they affect data subjects.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Choose the scan cadence: daily, weekly, or on demand. High-traffic customer-facing sites should be scanned daily to catch consent violations before they affect data subjects.',
            position: 'bottom',
            action: { type: 'select', target: '[data-testid="scan-frequency"]', value: 'weekly' },
        },
        {
            step_id: 'ps_notifications',
            target: '.dm-form-field fieldset',
            title: 'Notification Preferences',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Notification Preferences',
            description: 'Configure alerts for new issues, score changes, or scan completions. Immediate notifications on new violations let you remediate before a regulator or data subject reports the issue.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Configure alerts for new issues, score changes, or scan completions. Immediate notifications on new violations let you remediate before a regulator or data subject reports the issue.',
            position: 'bottom',
        },
        {
            step_id: 'ps_save_settings',
            target: '.dm-form-actions button[type="submit"]',
            title: 'Save Configuration',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Save Configuration',
            description: 'Click Save to apply your monitoring configuration. Scans will begin according to the frequency you selected.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Click Save to apply your monitoring configuration. Scans will begin according to the frequency you selected.',
            position: 'top',
            action: { type: 'click', target: '.dm-form-actions button[type="submit"]' },
        },
        {
            step_id: 'ps_run_scan',
            navigate_to: '/admin/privacy-scanner/monitoring',
            target: '.btn-primary',
            title: 'Run a Scan Now',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Run a Scan Now',
            description: 'Trigger an immediate scan to check for cookie consent issues, unauthorized trackers, and privacy policy gaps. Results become audit evidence of continuous monitoring.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Trigger an immediate scan to check for cookie consent issues, unauthorized trackers, and privacy policy gaps. Results become audit evidence of continuous monitoring.',
            position: 'top',
            action: { type: 'click', target: '.btn-primary' },
            duration_ms: 100,
        },
        {
            step_id: 'ps_filters',
            target: '.dm-filters',
            title: 'Filter Scan Results',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Filter Scan Results',
            description: 'Filter by property, compliance score, or severity to triage the most critical findings first. Focus on high-severity issues that pose immediate regulatory risk.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Filter by property, compliance score, or severity to triage the most critical findings first. Focus on high-severity issues that pose immediate regulatory risk.',
            position: 'bottom',
        },
        {
            step_id: 'ps_complete',
            target: '.dm-page',
            title: 'Privacy Scanner Tour Complete',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Privacy Scanner Tour Complete',
            description: 'You can now configure continuous monitoring, detect consent violations, and generate scan evidence that demonstrates proactive ePrivacy and GDPR compliance to regulators.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: You can now configure continuous monitoring, detect consent violations, and generate scan evidence that demonstrates proactive ePrivacy and GDPR compliance to regulators.',
            position: 'bottom',
        },
    ],
};
//# sourceMappingURL=privacy-scanner.js.map